<template>
    <div class="mobile-menu-wrap">

        <div class="menu-content" v-if="isActive" :class="isShow && `active`">

            <ul v-if="activeMenuLevel2" class="browseNavList">
                <li class="browseNavItem">
                    <div class="browseNavLink browseNavItemBack" @click.prevent="backToMenuLevel2">
                        <span class="browseNavArrow">
                            <span class="material-symbols-outlined">arrow_back</span>
                        </span>
                        <span class="browseNavText">{{ $t(`back`) }}</span>
                    </div>
                </li>

                <li class="browseNavItem" v-for="(item, index) in menuLevel3" :key="index">
                    <a class="browseNavLink external-link" :href="item.externalLink" target="_blank"
                        v-if="item.externalLink">
                        <span class="browseNavText">{{ item.name }}</span>
                        <span class="browseNavArrow">
                            <span class="material-symbols-outlined">call_made</span>
                        </span>
                    </a>

                    <div class="browseNavLink" v-else-if="item.items">
                        <span class="browseNavText">{{ item.name }}</span>
                        <span class="browseNavArrow">
                            <span class="material-symbols-outlined">chevron_right</span>
                        </span>
                    </div>

                    <a class="browseNavLink" v-else :href="item.uri">
                        <span class="browseNavText">{{ item.name }}</span>
                    </a>
                </li>
            </ul>

            <ul v-else-if="activeMenuLevel1" class="browseNavList">
                <li class="browseNavItem">
                    <div class="browseNavLink browseNavItemBack" @click.prevent="backToMenuLevel1">
                        <span class="browseNavArrow">
                            <span class="material-symbols-outlined">arrow_back</span>
                        </span>
                        <span class="browseNavText">{{ $t(`back`) }}</span>
                    </div>
                </li>

                <li class="browseNavItem" v-for="(item, index) in menuLevel2" :key="index">

                    <a class="browseNavLink external-link" :href="item.externalLink" target="_blank"
                        v-if="item.externalLink">
                        <span class="browseNavText">{{ item.name }}</span>
                        <span class="browseNavArrow">
                            <span class="material-symbols-outlined">call_made</span>
                        </span>
                    </a>

                    <div class="browseNavLink" v-else-if="item.items" @click="activeMenuLevel2Handle(item)">
                        <span class="browseNavText">{{ item.name }}</span>
                        <span class="browseNavArrow">
                            <span class="material-symbols-outlined">chevron_right</span>
                        </span>
                    </div>

                    <a class="browseNavLink" v-else :href="item.uri">
                        <span class="browseNavText">{{ item.name }}</span>
                    </a>
                </li>
            </ul>

            <ul v-else class="browseNavList">
                <li class="browseNavItem">
                    <a href="/" class="browseNavLink" @click.prevent="backToMenuLevel2">
                        <span class="browseNavText">{{ $t(`Home`) }}</span>
                    </a>
                </li>

                <li class="browseNavItem" v-for="(item, index) in menuLevel1" :key="index">

                    <a class="browseNavLink external-link" :href="item.externalLink" target="_blank"
                        v-if="item.externalLink">
                        <span class="browseNavText">{{ item.name }}</span>
                        <span class="browseNavArrow">
                            <span class="material-symbols-outlined">call_made</span>
                        </span>
                    </a>

                    <div class="browseNavLink" v-else-if="item.items" @click="activeMenuLevel1Handle(item)">
                        <span class="browseNavText">{{ item.name }}</span>
                        <span class="browseNavArrow">
                            <span class="material-symbols-outlined">chevron_right</span>
                        </span>
                    </div>

                    <a class="browseNavLink" v-else :href="item.uri">
                        <span class="browseNavText">{{ item.name }}</span>
                    </a>

                </li>
            </ul>

            <hr v-if="menuRed.length > 0" />
            <ul class="browseNavList browseNavListRed" v-if="menuRed.length > 0">
                <li class="browseNavItem" v-for="(item, index) in menuRed" :key="index">
                    <a class="browseNavLink external-link" :href="item.url" target="_blank" v-if="item.url">
                        <span class="browseNavText">{{ item.name }}</span>
                        <span class="browseNavArrow">
                            <span class="material-symbols-outlined">call_made</span>
                        </span>
                    </a>
                    <a class="browseNavLink" v-else :href="item.uri">
                        <span class="browseNavText">{{ item.name }}</span>
                    </a>

                </li>
            </ul>

            <hr />
            <ul class="browseNavList">
                <li class="browseNavItem" v-if="isAuth">
                    <a class="browseNavLink" :href="`/account`">
                        <span class="browseNavText">{{ $t(`Profile`) }}</span>
                    </a>
                </li>
                <li class="browseNavItem" v-else>
                    <a class="browseNavLink" :href="`/login`">
                        <span class="browseNavText">{{ $t(`Login`) }}</span>
                    </a>
                </li>
            </ul>

            <hr />

            <ul class="language-list">
                <li v-for="(item, index) in languages" :key="index">
                    <a class="lang-link" :class="(locale == index && `active`)" :href="`/lang/${index}`">
                        <span class="lang-text">{{ index }}</span>
                    </a>
                </li>
            </ul>
            <div class="copyright">{{ $t(`copyright`) }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['menus', 'isActiveMobileMenu', 'menuRed', 'isAuth', 'languages', 'locale'],
    data() {
        return {
            isActive: false,
            isShow: false,
            activeMenuLevel1: null,
            activeMenuLevel2: null,

        }
    },

    created() {
        setTimeout(() => {
            this.isActive = true

            this.showHandle()
        }, 300);
    },

    computed: {
        menuLevel1() {
            return this.menus.map((menu) => menu);
        },
        menuLevel2() {
            if (!this.activeMenuLevel1) {
                return []
            }

            if (!this.activeMenuLevel1.items) {
                return []
            }

            return this.activeMenuLevel1.items.map((menu) => menu)
        },
        menuLevel3() {
            if (!this.activeMenuLevel2) {
                return []
            }

            if (!this.activeMenuLevel2.items) {
                return []
            }

            return this.activeMenuLevel2.items.map((menu) => menu)
        },


    },

    methods: {
        showHandle() {
            setTimeout(() => {
                this.isShow = true
            }, 100);
        },
        activeMenuLevel1Handle(item) {
            this.activeMenuLevel2 = null
            if (item.items) {
                this.activeMenuLevel1 = item
            }
            else {
                this.activeMenuLevel1 = null
            }
        },
        activeMenuLevel2Handle(item) {
            if (item.items) {
                this.activeMenuLevel2 = item
            }
            else {
                this.activeMenuLevel2 = null
            }
        },

        backToMenuLevel1() {
            this.activeMenuLevel1 = null
        },

        backToMenuLevel2() {
            this.activeMenuLevel2 = null
        }
    }
}
</script>

<style lang="scss" scoped>
.mobile-menu-wrap {
    flex: 1;
    background-color: #fff;
    overflow-y: auto;
    // position: fixed;
    // top: 0;
    // left: 0;

}

.menu-content {

    opacity: 0;
    user-select: none;
    -webkit-overflow-scrolling: touch;
    // visibility: hidden;
    transform: translateY(30px);
    transition: opacity 665ms cubic-bezier(0, 0, .1, 1), transform 665ms cubic-bezier(0, 0, .1, 1);
    transition-delay: 195ms, .13s;

    hr {
        border-top-color: #ccc;
        margin-left: 24px;
        margin-right: 24px;
    }

    &.active {
        padding-top: 24px;
        padding-bottom: 30px;
        opacity: 1;
        transform: translateY(0);
        visibility: visible;
        opacity: 1;
        transition-delay: 0s;
    }

    // display: flex;
    // flex-direction: column;

    // display: none;
}

.browseNavList {
    display: flex;
    flex-direction: column;

    padding: 0;
    margin: 0;
}

.browseNavItem {
    display: flex;
    flex-direction: column;

    margin: 0;
    padding: 0;
}

.browseNavLink {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px 8px 24px;
    gap: 10px;
    overflow: hidden;

    font-size: var(--nav-mobile-font-size, 28px);
    color: var(--nav-mobile-font-color, #1c1d1f);

    gap: 5px;
    cursor: pointer;

    text-decoration: none;

    &.browseNavItemBack {
        justify-content: flex-start;
        color: #999;

        .browseNavArrow>span {
            font-size: 24px;
        }
    }

    &.external-link {
        justify-content: flex-start;

        .browseNavArrow>span {
            font-size: 24px;
            color: var(--nav-mobile-font-color, #1c1d1f);
        }
    }

    .browseNavArrow {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 30px;
        height: 30px;
        color: #999;


        >span {
            font-size: 30px;
        }
    }
}

.browseNavListRed {
    .browseNavLink {
        color: #c32237;

        .browseNavArrow>span {
            color: #c32237;
        }
    }
}

.copyright {
    padding-left: 24px;
    padding-right: 24px;
    color: #999;
}

.language-list {
    padding-left: 24px;
    padding-right: 24px;

    display: flex;
    align-items: center;

    >li {
        display: flex;

        >a {
            background-color: #ccc;
            color: #000;
            padding: 4px 24px;
            display: flex;
            justify-content: center;
            text-align: center;

            text-transform: uppercase;
            text-decoration: none;

            &.active {
                background-color: var(--header-bg, #712d7d);
                color: #fff;
            }
        }
    }
}
</style>